import { getAllItems } from '../../../menu-services/items-service'
import { getModifierItems } from '../../../menu-services/modifiers-service'
import _ from 'lodash'

export function cleanRequirementUpcharge (requirement, menuBlob) {
  if (!_.has(requirement, 'upcharge.itemBased')) return

  const availableItems = getAllItems(menuBlob).map(it => it.id)
  const availableModifiers = getModifierItems(menuBlob).map(it => it.id)

  requirement.upcharge.itemBased = requirement.upcharge.itemBased
    .filter(it => it.type === 'ITEM' ? availableItems.includes(it.itemId) : availableModifiers.includes(it.itemId))
}
